/* 🤖 this file was generated by script */
export const wiconDownload03 = {
  name: 'download_03',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12l4 4m0 0l4-4m-4 4V8m10 4a10 10 0 11-20 0 10 10 0 0120 0z"/></svg>`,
};
